import { useLaunchDarklyStatus } from "@assetwatch/auth";
import { FullPageLoading } from "@assetwatch/ui";
import type { ReactNode } from "react";

export function AppFeatureGate({ children }: { children: ReactNode }) {
  const hasLaunchDarklyClient = Boolean(
    import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID,
  );
  const { isReady } = useLaunchDarklyStatus();

  if (hasLaunchDarklyClient && !isReady) {
    return <FullPageLoading />;
  }

  return <>{children}</>;
}
